import { render, staticRenderFns } from "./activePlayers.vue?vue&type=template&id=1838cfac&scoped=true"
import script from "./activePlayers.vue?vue&type=script&lang=js"
export * from "./activePlayers.vue?vue&type=script&lang=js"
import style0 from "./activePlayers.vue?vue&type=style&index=0&id=1838cfac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838cfac",
  null
  
)

export default component.exports